import { useTranslation } from "react-i18next";
import { Appbar as Bar } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";

type Props = {
	title?: string;
	showClose?: boolean;
	handleClose?: () => void;
};

export const ChatAppbar = ({ title, showClose = true, handleClose }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Bar.Header style={{ backgroundColor: theme.colors.primary }}>
			<Bar.Content
				title={title ?? t("redeemCopilot.chat.fallbackTitle")}
				color={theme.colors.onPrimary}
			/>
			{showClose && handleClose && (
				<Bar.Action
					icon="close"
					color={theme.colors.onPrimary}
					onPress={handleClose}
				/>
			)}
		</Bar.Header>
	);
};
